"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayDemand = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const enums_1 = require("@bemlo/enums");
const schedule_1 = require("@bemlo/schedule");
const constants_1 = require("../../../../constants");
const elements_1 = require("../../../../elements");
const Cell_1 = require("../components/Cell");
const Row_1 = require("../components/Row");
const useSchedule_1 = require("../useSchedule");
const Wrapper = styled_1.default.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    fontWeight: 500,
    color: constants_1.Color.CHARCOAL,
});
const DayDemand = (props) => {
    const { days, shifts: allShifts, isScrolled, zoom } = (0, useSchedule_1.useSchedule)();
    const handleSetGraphData = (dayIndex) => {
        const day = days[dayIndex];
        const shiftsOnDay = allShifts.filter((shift) => 
        // Correct day
        shift.date === day.dateISO &&
            // Correct unit
            shift.unitId === props.unitId &&
            // Correct schedule resource if set
            (shift.scheduleResourceId === props.scheduleResourceId ||
                !props.scheduleResourceId));
        const shiftsFilled = shiftsOnDay.filter(({ rowKey, bookedCandidateId }) => {
            if (props.countRowsAsFilled && typeof rowKey === 'number')
                return true;
            return !!bookedCandidateId;
        });
        const fill = Array.from({ length: 96 }, () => 0);
        const flex = Array.from({ length: 96 }, () => 0);
        shiftsFilled.forEach((booking) => {
            const slots = (0, schedule_1.shiftToQuarters)(booking);
            slots.forEach((value, slot) => {
                if (booking.activity === enums_1.ShiftActivity.WORK) {
                    fill[slot] += value;
                    flex[slot] += value;
                }
                if (booking.activity === enums_1.ShiftActivity.FLEX) {
                    flex[slot] += value;
                }
            });
        });
        const demand = props.demands?.find((d) => d.date === day.dateISO)?.demand;
        const min = demand?.min || [];
        const max = demand?.max || [];
        props.setGraphData({
            date: day.dateISO,
            day: dayIndex,
            fill: fill.map((value, index) => ({
                x: index,
                y: value,
            })),
            flex: flex.map((value, index) => ({
                x: index,
                y: value,
            })),
            min: min.map((value, index) => ({
                x: index,
                y: value,
            })),
            max: max.map((value, index) => ({
                x: index,
                y: value,
            })),
            shifts: shiftsOnDay,
        });
    };
    const isSmall = props.size === 'sm';
    return ((0, jsx_runtime_1.jsxs)(Row_1.Row, { children: [(0, jsx_runtime_1.jsx)(Cell_1.Cell, { isTitle: true, rowSpan: 1, rightShadow: isScrolled, children: props.title ? ((0, jsx_runtime_1.jsx)(elements_1.Flex, { styles: { height: '100%', alignItems: 'center', pl: 2 }, children: (0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, fontSize: 13, children: props.title }) })) : null }), days.map((day, dayIndex) => {
                return ((0, jsx_runtime_1.jsx)(Cell_1.Cell, { disabled: !day.withinRange, weekend: day.isWeekend, children: (0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsx)(elements_1.Button, { size: isSmall ? 'xs' : 'sm', design: "transparent-light", icon: "ChartBarIcon", onClick: () => handleSetGraphData(dayIndex), children: zoom === 'week' ? 'Bemanning' : '' }) }) }, day.dateISO));
            }), (0, jsx_runtime_1.jsx)(elements_1.Dialog, { isOpen: !!props.graphData, onClose: () => props.setGraphData(undefined), children: (0, jsx_runtime_1.jsx)(elements_1.Paper, { children: (0, jsx_runtime_1.jsxs)(elements_1.Flex, { col: true, gap: 3, children: [(0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 2.5, items: "center", styles: { px: 2, py: 1.5 }, children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, children: props.graphData?.date }), (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "xs", design: "white", icon: "ChevronLeftIcon", disabled: props.graphData?.day === 0, onClick: () => handleSetGraphData((props.graphData?.day ?? days.length) - 1) }), (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "xs", design: "white", icon: "ChevronRightIcon", disabled: props.graphData?.day === days.length - 1, onClick: () => handleSetGraphData((props.graphData?.day ?? 0) + 1), styles: { mr: 'auto' } }), props.dialogControls, (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "xs", design: "transparent-light", icon: "XIcon", onClick: () => props.setGraphData(undefined) })] }), props.dialogContent] }) }) })] }));
};
exports.DayDemand = DayDemand;
